/* eslint-disable */
import { IState } from "@/interfaces/IState";

export const pagination = {
    state: {
        page: 0
    },
    mutations: {
        SET_CURRENT_PAGE(state: IState, payload: any) {
            state.page = payload;
        }
    },
    actions: {
        setCurrentPage(context: any, payload: any) {
            context.commit("SET_CURRENT_PAGE", payload);
        }
    },
    getters: {
        getCurrentPage(state: any) {
            return state.page;
        }
    }
};
